import { IconProps } from "../../utils/global-types/global-types";

const FavouriteFilledIcon = ({ className, ...rest }: IconProps) => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className ? className : "w-6 h-6"}
      {...rest}
    >
      <path
        d="M14.9989 6.31721L11.9199 5.86979L10.5428 3.0797C10.011 2.00196 8.47304 2.00229 7.94137 3.07966L6.56435 5.86975L3.4853 6.31721C2.29588 6.49001 1.8211 7.9527 2.68141 8.79137L4.90945 10.9632L4.38349 14.0297C4.18034 15.2143 5.42462 16.1178 6.48815 15.5589L9.24214 14.1109L11.9962 15.5589C13.0582 16.1172 14.3039 15.2141 14.1008 14.0297L13.5749 10.9631L15.8029 8.79134C16.6634 7.95237 16.1878 6.48998 14.9989 6.31721ZM14.9349 7.90105L12.4729 10.3009C12.3264 10.4438 12.2595 10.6495 12.2941 10.8512L12.8753 14.2399C12.9045 14.4101 12.7274 14.5386 12.5746 14.4584L9.53136 12.8584C9.35029 12.7633 9.13388 12.7633 8.95281 12.8584L5.90952 14.4584C5.75668 14.5387 5.57968 14.4101 5.60886 14.2399L6.19008 10.8512C6.22464 10.6495 6.1578 10.4438 6.0113 10.3009L3.54922 7.90105C3.42556 7.78051 3.4932 7.57245 3.66408 7.54757L7.06656 7.05316C7.26901 7.02373 7.44408 6.8966 7.53463 6.71312L9.05629 3.62991C9.13268 3.47518 9.35149 3.47507 9.42791 3.62995L10.9496 6.71312C11.0401 6.8966 11.2152 7.02376 11.4176 7.05316L14.8201 7.54757C14.991 7.57245 15.0586 7.78055 14.9349 7.90105Z"
        fill="currentColor"
      />
      <path
        d="M11.5 6.5L9.5 3L7 6.5L3 7.5L5.5 11L5 15L9.5 13.5L13 15V10.5L15.5 7.5L11.5 6.5Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default FavouriteFilledIcon;
